var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"background-color":"#F6F9F7"},attrs:{"storage":_vm.sideNav}}),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }